export const getEnvUrl = (envUrlPrefix?: string) =>
    envUrlPrefix
        ? envUrlPrefix.replace("MIRROR_HOST", `${window.location.protocol}//${window.location.hostname}`)
        : envUrlPrefix;
